export class RemitoVehicleCreationDetails {
  public ptoEmision: Array<IdDescModel>;
  public destinatario: Array<DestinatarioBriefModel>;
  public transporte: Array<TransporteBriefModel>;
  public origen: Array<IdDescModel>;
  public impresoras: Array<IdDescModel>;
  public chargeTo: Array<IdDescModel>;
  public pdfName: Array<IdDescModel>;
}

export class IdDescModel {
  public id: string;
  public desc: string;
  public dlCiudad: string;
}

export class DestinatarioBriefModel {
  public id: string;
  public desc: string;
  public dlDomicilio: string;
  public dlCiudad: string;
  public dlDescPcia: string;
  public dlCodPostal: string;
  public nroIibb: string;
  public condicionIva: string;
  public nroCuit: string;
}

export class TransporteBriefModel {
  public id: string;
  public desc: string;
  public domicilio: string;
  public localidad: string;
  public codPostal: string;
  public cuit: string;
}

export class Clase {
  id: string;
  viewValue: string;
}
